import PropTypes from 'prop-types';
import React from 'react';

import { NewspaperIcon } from '@heroicons/react/solid';
import noop from 'lodash/noop';

import Modal from 'components/Modal';
import Button from 'components/buttons/Button';

const CompanyArticleDeleteModal = ({
  open = false,
  title = '',
  onClose = noop,
  onDelete = noop,
}) => (
  <Modal open={open}>
    <Modal.Icon Icon={NewspaperIcon} />
    <Modal.Title>Delete article</Modal.Title>
    <Modal.Description>
      Are you sure you want to delete article: <b>{title}</b>
    </Modal.Description>
    <Modal.RightButtons>
      <Button type="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button
        onClick={onDelete}
        eventType="pressPage_update"
        eventProperties={{ action: 'article_delete' }}
        data-test-id="company-articles-deleteModal-delete"
      >
        Delete article
      </Button>
    </Modal.RightButtons>
  </Modal>
);

CompanyArticleDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CompanyArticleDeleteModal;
